/**
 * The bit of the phrase library a player is allowed to think about.
 *
 * Since backlog item 63 a player's lines arrive grouped by theme, in the order the admin set on the
 * console's Banter lines screen, so there is nothing left to sort or draw here: the moods, the
 * weighted random six and "Give me more" went with that change. What is left is reading a line's
 * gap and filling it in.
 */

/** A line's required tokens, whichever shape they arrived in. */
function tokens(phrase) {
  const raw = phrase.requiredTokens;
  if (Array.isArray(raw)) return raw;
  if (typeof raw === 'string') return raw.split(',').map((t) => t.trim()).filter(Boolean);
  return [];
}

/**
 * What a line needs before it can be posted: 'player', 'team', or null for nothing. A line has at
 * most one gap - the server refuses any other kind of line when it is written.
 */
export function gapOf(phrase) {
  const needs = tokens(phrase);
  if (needs.includes('target')) return 'player';
  if (needs.includes('team')) return 'team';
  return null;
}

/**
 * A line before anybody is chosen, with its gap as a blank: "Taxi for ___". Shown only on the
 * step where the player is picking a line, so the blank is a question rather than a leak.
 */
export function readable(phrase) {
  return String(phrase.text || '')
    .replace(/\{\{\s*(target|team)\s*}}/g, '___')
    .trim();
}

/**
 * A fully rendered line — no braces, no "someone", nothing a player should not see.
 *
 * This is a preview only. The line that is actually stored is rendered on the server
 * from the phrase id, so what a player reads here and what a player can cause to
 * exist are deliberately not the same code path.
 */
export function renderPhrase(phrase, { playerName, teamName } = {}) {
  return String(phrase.text || '')
    .replace(/\{\{\s*target\s*}}/g, playerName || '')
    .replace(/\{\{\s*team\s*}}/g, teamName || '')
    .replace(/\s{2,}/g, ' ')
    .trim();
}
